// src/TEST/gateways/NoGatewayAvailable.js
import React from "react";

const NoGatewayAvailable = () => {
  return (
    <div className='piranha-payment-warning'>
      <strong>⚠️ Payment gateway unavailable</strong>
      <hr />
      <div>
        This plan does not have any payment gateway configured yet. You cannot
        complete the purchase at this time.
      </div>
    </div>
  );
};

export default NoGatewayAvailable;
